export enum MealType{
    STARTER = "STARTER",
    MAIN_COURSE = "MAIN COURSE",
    DESSERT = "DESSERT",
    SIDE_DISH = 'SIDE_DISH',
    BEVERAGE = 'BEVERAGE',
}
